
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./transactions.resolver.cjs.production.min.js')
} else {
  module.exports = require('./transactions.resolver.cjs.development.js')
}
